<template>
  <q-list>
    <sticky-header static color="black">
      Filters
    </sticky-header>

    <q-item-wrapper
      v-if="hasChips"
      dense
    >
      <div>
        <q-chip v-if="restrictToExtension" outline>
          Extension: <b class="q-ml-sm">.{{ restrictToExtension }}</b>
        </q-chip>

        <q-chip
          v-if="filterVals.hideFromCatName"
          outline
          removable
          @remove="filterVals.hideFromCatName = null, applyFilters()"
        >
          Hiding Category: <b class="q-ml-sm">{{ filterVals.hideFromCatName }}</b>
        </q-chip>
      </div>
    </q-item-wrapper>

    <q-item-wrapper>
      <q-select
        :model-value="filterVals.type"
        outlined
        stack-label
        emit-value
        map-options
        label="File Type"
        behavior="menu"
        :options="typeOptions"
        :disable="!!restrictToType"
        @update:model-value="filterVals.type = restrictToType || $event"
      />
    </q-item-wrapper>

    <q-item-wrapper>
      <CatSelect
        :model-value="filterVals.category"
        :clearable="filterVals.category !== -1"
        outlined
        stack-label
        with-no-cat
        label="Category"
        behavior="menu"
        @clear="filterVals.category = -1"
        @update:model-value="filterVals.category = $event, filterVals.hideFromCatName = null"
      />
    </q-item-wrapper>

    <q-item-wrapper v-if="can(permissions.canManageFiles)">
      <user-input-popover
        v-model="filterVals.creator"
        outlined
        label="Filter by creator"
        placeholder="Start typing..."
        class="full-width"
      />
    </q-item-wrapper>

    <q-item-wrapper>
      <q-btn
        label="Apply Filters"
        color="teal"
        :loading="loading"
        size="12px"
        class="full-width"
        @click="applyFilters"
      />
    </q-item-wrapper>
  </q-list>
</template>

<script>
import CatSelect from 'components/app/files/partials/categories/CatSelect.vue'

function typeValidator (value) {
  return [null, 'DOCUMENT', 'IMAGE'].includes(value)
}

export default {
  components: {
    CatSelect
  },
  props: {
    filterVals: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    restrictToType: {
      type: String,
      default: null,
      validator: typeValidator
    },
    restrictToExtension: {
      type: String,
      default: null
    }
  },
  emits: ['applyFilters'],
  data () {
    return {
      typeOptions: [
        { label: 'Any Type', value: null },
        { label: 'Images', value: 'IMAGE' },
        { label: 'Documents', value: 'DOCUMENT' }
      ]
    }
  },
  computed: {
    hasChips () {
      return !!this.restrictToExtension || !!this.filterVals.hideFromCatName
    }
  },
  methods: {
    applyFilters () {
      this.$emit('applyFilters')
    }
  }
}
</script>
